/* eslint-disable class-methods-use-this */
import MessageRaw from '../utils/MessageRaw'
import DashBoardMessageEntity from '../utils/DashBoardMessageEntity'

class MessagesNormalizer {
  normalizeDashboard(Message: MessageRaw[]): DashBoardMessageEntity {
    return {
      id: Message[0].id,
      messagetext: Message[0].messagetext,
    }
  }
}

export default new MessagesNormalizer()
